/**
 * Header Component
 * Application header with title and action buttons
 */

import { Status, AppHeader, InfoButton } from '@midi-volca-drum/ui-components';

interface HeaderProps {
  connected: boolean;
  onConnectClick: () => void;
  onAboutClick: () => void;
}

export const Header = ({ connected, onConnectClick, onAboutClick }: HeaderProps) => {
  return (
    <AppHeader
      title='VOLCA DRUM'
      actions={
        <>
          <Status connected={connected} onClick={onConnectClick} />
          <InfoButton onClick={onAboutClick} />
        </>
      }
    />
  );
};
